import { Helmet } from 'react-helmet';
import { Outlet, useLocation } from 'react-router-dom';
import { ToastContainer as BaseToastContainer } from 'react-toastify';
import { Buffer } from 'buffer';
import { useEffect } from 'react';

import styled from 'styled-components';

import { PortalModal } from '@/ui-kit/modal/PortalModal';
import { useDashboardConfig } from '@/hooks/useDashboardConfig';

import { useMatomo } from '@/features/matomo/useMatomo';

import { useRoute } from '@/router/hooks/useRoute';

globalThis.Buffer = Buffer;

const ToastContainer = styled(BaseToastContainer)`
  // https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity
  top: 0em;
  left: 50%;
  &&&.Toastify__toast-container {
    padding: 0px;
    width: 50em;
  }
  .Toastify__toast {
    min-height: 2em;
  }
  .Toastify__close-button {
    opacity: 1;
    align-self: center;
  }
  .Toastify__close-button > svg {
    height: 1.5em;
    width: 1.5em;
  }
  .Toastify__toast--dark {
    background-color: ${({ theme }) => theme.palette.dark};
    color: ${({ theme }) => theme.palette.light};
  }
  .Toastify__toast--default {
    background-color: ${({ theme }) => theme.palette.primary};
    color: ${({ theme }) => theme.palette.light};
  }
  .Toastify__toast--info {
    background-color: ${({ theme }) => theme.palette.primary};
    color: ${({ theme }) => theme.palette.light};
  }
  .Toastify__toast--success {
    background-color: ${({ theme }) => theme.palette.success};
    color: ${({ theme }) => theme.palette.light};
  }
  .Toastify__toast--warning {
    background-color: ${({ theme }) => theme.palette.tertiary};
    color: ${({ theme }) => theme.palette.light};
  }
  .Toastify__toast--error {
    background-color: ${({ theme }) => theme.palette.error};
    color: ${({ theme }) => theme.palette.light};
  }
  .Toastify__progress-bar,
  .Toastify__progress-bar--success {
    background: #ffffff;
  }
`;

export const AppPage = () => {
  const dashboardConfig = useDashboardConfig();

  const { pathname } = useLocation();

  const { triggerPageView, isInitialized } = useMatomo();

  useRoute();

  useEffect(() => {
    if (isInitialized) {
      triggerPageView(pathname);
    }
  }, [pathname, triggerPageView, isInitialized]);

  if (!dashboardConfig) return null;

  return (
    <>
      <Helmet
        titleTemplate={`%s | Treezor Connect - ${dashboardConfig?.site.name} Dashboard`}
        defaultTitle={dashboardConfig?.site.name}
      />
      <PortalModal />
      <ToastContainer limit={4} position="top-center" stacked />
      <Outlet />
    </>
  );
};
